// Generated by psc version 0.10.2
"use strict";
var Prelude = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Prelude.purs");
var Control_Comonad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Comonad.purs");
var Control_Extend = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Extend.purs");
var Data_Functor_Invariant = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-invariant/src/Data/Functor/Invariant.purs");
var Data_Monoid = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-monoid/src/Data/Monoid.purs");
var Data_Newtype = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-newtype/src/Data/Newtype.purs");
var Data_Eq = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Eq.purs");
var Data_Ord = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Ord.purs");
var Data_Bounded = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Bounded.purs");
var Data_Functor = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Functor.purs");
var Control_Apply = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Apply.purs");
var Control_Applicative = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Applicative.purs");
var Control_Bind = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Bind.purs");
var Control_Monad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Monad.purs");
var Data_Show = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Show.purs");
var Data_Semigroup = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semigroup.purs");
var Data_Semiring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semiring.purs");
var Multiplicative = function (x) {
    return x;
};
var showMultiplicative = function (dictShow) {
    return new Data_Show.Show(function (v) {
        return "(Multiplicative " + (Data_Show.show(dictShow)(v) + ")");
    });
};
var semigroupMultiplicative = function (dictSemiring) {
    return new Data_Semigroup.Semigroup(function (v) {
        return function (v1) {
            return Data_Semiring.mul(dictSemiring)(v)(v1);
        };
    });
};
var ordMultiplicative = function (dictOrd) {
    return dictOrd;
};
var newtypeMultiplicative = new Data_Newtype.Newtype(function (n) {
    return n;
}, Multiplicative);
var monoidMultiplicative = function (dictSemiring) {
    return new Data_Monoid.Monoid(function () {
        return semigroupMultiplicative(dictSemiring);
    }, Data_Semiring.one(dictSemiring));
};
var invariantMultiplicative = new Data_Functor_Invariant.Invariant(function (f) {
    return function (v) {
        return function (v1) {
            return f(v1);
        };
    };
});
var functorMultiplicative = new Data_Functor.Functor(function (f) {
    return function (v) {
        return f(v);
    };
});
var extendMultiplicative = new Control_Extend.Extend(function () {
    return functorMultiplicative;
}, function (f) {
    return function (x) {
        return f(x);
    };
});
var eqMultiplicative = function (dictEq) {
    return dictEq;
};
var comonadMultiplicative = new Control_Comonad.Comonad(function () {
    return extendMultiplicative;
}, Data_Newtype.unwrap(newtypeMultiplicative));
var boundedMultiplicative = function (dictBounded) {
    return dictBounded;
};
var applyMultiplicative = new Control_Apply.Apply(function () {
    return functorMultiplicative;
}, function (v) {
    return function (v1) {
        return v(v1);
    };
});
var bindMultiplicative = new Control_Bind.Bind(function () {
    return applyMultiplicative;
}, function (v) {
    return function (f) {
        return f(v);
    };
});
var applicativeMultiplicative = new Control_Applicative.Applicative(function () {
    return applyMultiplicative;
}, Multiplicative);
var monadMultiplicative = new Control_Monad.Monad(function () {
    return applicativeMultiplicative;
}, function () {
    return bindMultiplicative;
});
module.exports = {
    Multiplicative: Multiplicative, 
    newtypeMultiplicative: newtypeMultiplicative, 
    eqMultiplicative: eqMultiplicative, 
    ordMultiplicative: ordMultiplicative, 
    boundedMultiplicative: boundedMultiplicative, 
    functorMultiplicative: functorMultiplicative, 
    invariantMultiplicative: invariantMultiplicative, 
    applyMultiplicative: applyMultiplicative, 
    applicativeMultiplicative: applicativeMultiplicative, 
    bindMultiplicative: bindMultiplicative, 
    monadMultiplicative: monadMultiplicative, 
    extendMultiplicative: extendMultiplicative, 
    comonadMultiplicative: comonadMultiplicative, 
    showMultiplicative: showMultiplicative, 
    semigroupMultiplicative: semigroupMultiplicative, 
    monoidMultiplicative: monoidMultiplicative
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-monoid/src/Data/Monoid/Multiplicative.purs
// module id = 59
// module chunks = 0